module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Medium.e12afcc.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/couponsys/assets/fonts/NotoSansCJKkr-Medium.woff
// module id = DgOO
// module chunks = 0